import { pipe, takeWhile, equals, complement, invoker } from 'ramda';

const notEquals = complement(equals);

export const formatScreenshotTimestamp = (date = new Date()) =>
  pipe(invoker(0, 'toISOString'), takeWhile(notEquals('.')))(date);
